import type { MessageKey } from "@/i18n";

const MANAGER_AUDIT_FIELD_LABEL_KEYS = {
  addMatchWonPoints: "addMatchWonPoints",
  addPointsScore: "addPointsScore",
  addSetWonPoints: "addSetWonPoints",
  additionalReferees: "additionalReferees",
  additionalRefereeIds: "additionalReferees",
  address: "address",
  addressCoordinates: "addressCoordinates",
  allowAttachingMediaContent: "allowAttachingMediaContent",
  allowParticipantsToAddResults: "allowParticipantsToAddResults",
  approvalStatus: "approvalStatus",
  approvedEntries: "approvedEntries",
  attachmentsStatus: "attachmentsStatus",
  autoConfirmEntries: "autoConfirmEntries",
  autoConfirmSubmittedResults: "autoConfirmSubmittedResults",
  bestResultsLimit: "bestResultsLimit",
  captainRegistrationDeadline: "captainRegistrationDeadline",
  categories: "categories",
  category: "category",
  categoryId: "category",
  categoryDiscounts: "categoryDiscounts",
  categorySettingIds: "categorySettings",
  categorySettings: "categorySettings",
  city: "city",
  closeCaptainRegistration: "closeCaptainRegistration",
  closeRegistration: "closeRegistration",
  club: "club",
  color: "color",
  competitionType: "competitionType",
  consolation: "consolation",
  considerOnlyPaidRequestsInLimits: "considerOnlyPaidRequestsInLimits",
  considerRequestsInLimits: "considerRequestsInLimits",
  contactUrl: "contactUrl",
  coordinates: "coordinates",
  country: "country",
  coverPhoto: "coverPhoto",
  currency: "currency",
  customHotelsLink: "customHotelsLink",
  customInfoMessage: "customInfoMessage",
  customMatricesType: "customMatricesType",
  customSuccessMessage: "customSuccessMessage",
  datesToHide: "datesToHide",
  description: "description",
  discount: "discount",
  discountCap: "discountCap",
  discountExpireTime: "discountExpireTime",
  discountPer: "discountPer",
  discountStartTime: "discountStartTime",
  discountType: "discountType",
  drawType: "drawType",
  duplicatedFromId: "duplicatedFrom",
  enabledPushNotification: "enabledPushNotification",
  enableLiveScoring: "enableLiveScoring",
  enableLiveStream: "enableLiveStream",
  enablePracticeCourtsBooking: "enablePracticeCourtsBooking",
  enableTransferBooking: "enableTransferBooking",
  endDate: "endDate",
  endTime: "endTime",
  entryDeadline: "entryDeadline",
  entryFee: "entryFee",
  events: "events",
  extraTime: "extraTime",
  fee: "fee",
  fideRatedTournament: "fideRatedTournament",
  format: "format",
  gender: "gender",
  generalLimit: "generalLimit",
  groupType: "groupType",
  hideOtherParticipantResults: "hideOtherParticipantResults",
  hideResultsType: "hideResultsType",
  individualMetricLimit: "individualMetricLimit",
  isAllowPlayerScoreSubmission: "isAllowPlayerScoreSubmission",
  isAllowRosterSubmission: "isAllowRosterSubmission",
  isAllowScoreSubmission: "isAllowScoreSubmission",
  isCopyAllDivisionAndEntries: "isCopyAllDivisionAndEntries",
  isCPCRequired: "isCPCRequired",
  isCustomMatricesEnabled: "isCustomMatricesEnabled",
  isDisplayBirthYear: "isDisplayBirthYear",
  isDisplayCity: "isDisplayCity",
  isDisplayClub: "isDisplayClub",
  isDisplayPoints: "isDisplayPoints",
  isDisplayRank: "isDisplayRank",
  isDisplaySeeds: "isDisplaySeeds",
  isDisplaySegments: "isDisplaySegments",
  isDrawsEnabled: "isDrawsEnabled",
  isDuprRatingEnabled: "isDuprRatingEnabled",
  isDuprRequired: "isDuprRequired",
  isFeatured: "isFeatured",
  isGenerateDivisionMatches: "isGenerateDivisionMatches",
  isGroupsEnabled: "isGroupsEnabled",
  isHideEntries: "isHideEntries",
  isHideFromCalendar: "isHideFromCalendar",
  isLimitCount: "isLimitCount",
  isListAndResultEnabled: "isListAndResultEnabled",
  isManagerPayingPlatformFee: "isManagerPayingPlatformFee",
  isManagerPayingStripeFee: "isManagerPayingStripeFee",
  isMaxwillRequired: "isMaxwillRequired",
  isOrganizerRegEmailsEnabled: "isOrganizerRegEmailsEnabled",
  isPairingsEnabled: "isPairingsEnabled",
  isParticipantPreSignInRequired: "isParticipantPreSignInRequired",
  isPayForMyselfEnabled: "isPayForMyselfEnabled",
  isPlayerScoreAutoConfirm: "isPlayerScoreAutoConfirm",
  isPublish: "isPublish",
  isRegistrationEmailsEnabled: "isRegistrationEmailsEnabled",
  isRosterAutoConfirm: "isRosterAutoConfirm",
  isScoreAutoConfirm: "isScoreAutoConfirm",
  isVATAmount: "isVATAmount",
  isVTRD: "isVTRD",
  isWprEntriesEnabled: "isWprEntriesEnabled",
  isWprRequired: "isWprRequired",
  isWtnRatingEnabled: "isWtnRatingEnabled",
  leagueType: "leagueType",
  licenceIds: "licences",
  limit: "limit",
  link: "link",
  listAndResultShowIndividualTab: "listAndResultShowIndividualTab",
  listAndResultShowPointsTab: "listAndResultShowPointsTab",
  listAndResultShowTeamsTab: "listAndResultShowTeamsTab",
  listAndResultType: "listAndResultType",
  liveStreamingKeyChanged: "liveStreamingKeyChanged",
  liveStreamingLink: "liveStreamingLink",
  localRatedTournament: "localRatedTournament",
  loggedInUser: "loggedInUser",
  logo: "logo",
  mainDrawEntries: "mainDrawEntries",
  mde: "mainDrawEntries",
  mainDrawSeeds: "mainDrawSeeds",
  mds: "mainDrawSeeds",
  mainDrawWildCards: "mainDrawWildCards",
  mdwc: "mainDrawWildCards",
  makePrivate: "makePrivate",
  method: "method",
  moveToSingle: "moveToSingle",
  name: "name",
  numberOfCategories: "numberOfCategories",
  onlinePayments: "onlinePayments",
  onsiteEntryFee: "onsiteEntryFee",
  onsiteFee: "onsiteFee",
  order: "order",
  organizer: "organizer",
  pairing: "pairing",
  pairingsBlockType: "pairingsBlockType",
  partnerSearch: "partnerSearch",
  passwordChanged: "passwordChanged",
  paymentMethod: "paymentMethod",
  paymentQrCode: "paymentQrCode",
  paymentType: "paymentType",
  penaltyPoints: "penaltyPoints",
  points: "points",
  pointsForLoss: "pointsForLoss",
  pointsForTie: "pointsForTie",
  pointsForWin: "pointsForWin",
  position: "position",
  poster: "poster",
  preSignInEndDate: "preSignInEndDate",
  preSignInEndTime: "preSignInEndTime",
  preSignInStartDate: "preSignInStartDate",
  preSignInStartTime: "preSignInStartTime",
  promoCodeConfigured: "promoCodeConfigured",
  qualificationEntries: "qualificationEntries",
  qe: "qualificationEntries",
  qualificationSeeds: "qualificationSeeds",
  qs: "qualificationSeeds",
  qualificationWildCards: "qualificationWildCards",
  qwc: "qualificationWildCards",
  ratingSystems: "ratingSystems",
  referee: "referee",
  refereeId: "referee",
  registeredUsersInTournament: "registeredUsersInTournament",
  registrationLimit: "registrationLimit",
  registrationStartDate: "registrationStartDate",
  regulations: "regulations",
  registerLink: "registerLink",
  requiredMediaToUploadResult: "requiredMediaToUploadResult",
  resourceTitle: "resourceTitle",
  rounds: "rounds",
  rowCount: "rowCount",
  sendNotificationToParticipants: "sendNotificationToParticipants",
  service: "service",
  showOOP: "showOOP",
  showPairingsAndStandings: "showPairingsAndStandings",
  showTournamentChessManagerCalendar: "showTournamentChessManagerCalendar",
  singleCategory: "singleCategory",
  singleCategoryId: "singleCategory",
  skillLevel: "skillLevel",
  sortBy: "sortBy",
  sortOrder: "sortOrder",
  sortingPosition: "sortingPosition",
  startDate: "startDate",
  startTime: "startTime",
  state: "state",
  status: "status",
  submissionType: "submissionType",
  termsAndConditions: "termsAndConditions",
  tier: "tier",
  time: "time",
  timeAfterMove: "timeAfterMove",
  timeControl: "timeControl",
  timePerMove: "timePerMove",
  timeZone: "timeZone",
  title: "title",
  totalCounts: "totalCounts",
  tournamentCategoryGroup: "tournamentCategoryGroup",
  tournamentId: "tournament",
  type: "type",
  usedCounts: "usedCounts",
  vatAmount: "vatAmount",
  venue: "venue",
  videoLink: "videoUrl",
  videoUrl: "videoUrl",
  website: "website",
  withdrawlDeadline: "withdrawalDeadline",
  id: "publicId",
  tournament: "tournament",
  division: "division",
  draw: "draw",
  partner: "partner",
  group: "group",
  liveStanding: "liveStanding",
  team: "team",
  court: "court",
  courts: "courts",
  score: "score",
  entries: "entries",
  finalStandings: "finalStandings",
  formatBlocks: "formatBlocks",
  participant: "participant",
  place: "place",
  segment: "segment",
  comment: "comment",
  displayPlayOrder: "displayPlayOrder",
  displayMatches: "displayMatches",
  participantsAddScore: "participantsAddScore",
  hide: "hide",
  round: "round",
  roundNumber: "roundNumber",
  match: "match",
  matchNumber: "matchNumber",
  slot: "slot",
  operation: "operation",
  scheduledDate: "scheduledDate",
  updatedMatches: "updatedMatches",
  generatedMatches: "generatedMatches",
  removedMatches: "removedMatches",
  propagatedMatches: "propagatedMatches",
  mainDraw: "mainDraw",
  size: "size",
  qualifyingWinners: "qualifyingWinners",
  algorithm: "algorithm",
  generationMethod: "generationMethod",
  hidden: "hidden",
  displayParticipantClubs: "displayParticipantClubs",
  distributeClubMembers: "distributeClubMembers",
  firstMatchLosersToConsolation: "firstMatchLosersToConsolation",
  isDoubleRoundRobin: "isDoubleRoundRobin",
  isDelete: "isDelete",
  initialSeed: "initialSeed",
  playerIndexFromRegistration: "playerIndexFromRegistration",
  playerIndexFromPartner: "playerIndexFromPartner",
  pairingMode: "pairingMode",
  isFormedPair: "isFormedPair",
  sorting: "sorting",
  matchType: "matchType",
  isPublished: "isPublished",
  highlightFrom: "highlightFrom",
  highlightTo: "highlightTo",
  groups: "groups",
  entriesCount: "entriesCount",
  groupPlace: "groupPlace",
  pointsRatio: "pointsRatio",
  pointsWon: "pointsWon",
  pointsLoss: "pointsLoss",
  setRatio: "setRatio",
  matchesPlayed: "matchesPlayed",
  wins: "wins",
  draws: "draws",
  losses: "losses",
  goalsFor: "goalsFor",
  goalsAgainst: "goalsAgainst",
  goalDifference: "goalDifference",
  entry1: "entry1",
  entry2: "entry2",
  entry1Partner: "entry1Partner",
  entry2Partner: "entry2Partner",
  winner: "winner",
  winnerPartner: "winnerPartner",
  teamWinner: "teamWinner",
  team1Entry: "team1Entry",
  team2Entry: "team2Entry",
  date: "date",
  duration: "duration",
  venues: "venues",
  conflict: "conflict",
  teamScore: "teamScore",
  adjustedScore: "adjustedScore",
  scoreType: "scoreType",
  teamMatchType: "teamMatchType",
  matchStatus: "matchStatus",
  hideInOOP: "hideInOOP",
  isMatchInProgress: "isMatchInProgress",
  oopType: "oopType",
  periodStart: "periodStart",
  periodEnd: "periodEnd",
  weekNumber: "weekNumber",
  isMatchTie: "isMatchTie",
  assignedSegment: "assignedSegment",
  additionalSegment: "additionalSegment",
  seed: "seed",
  paymentStatus: "paymentStatus",
  participants: "participants",
  isWithoutPartner: "isWithoutPartner",
  isMergedFromSingleEntries: "isMergedFromSingleEntries",
  entry: "entry",
  rank: "rank",
  rapidElo: "rapidElo",
  standardElo: "standardElo",
  blitzElo: "blitzElo",
  fideTitle: "fideTitle",
  duprRating: "duprRating",
  wtnRating: "wtnRating",
  wprCompetitionRating: "wprCompetitionRating",
  wprSocialRating: "wprSocialRating",
  wprCompetitionRatingConfidenceLevel: "wprCompetitionRatingConfidenceLevel",
  wprSocialRatingConfidenceLevel: "wprSocialRatingConfidenceLevel",
  wprCompetitionRatingConfidence: "wprCompetitionRatingConfidence",
  wprSocialRatingConfidence: "wprSocialRatingConfidence",
  remindersSent: "remindersSent",
  generationMode: "generationMode",
  mainMatchCount: "mainMatchCount",
  teamMatchCount: "teamMatchCount",
  doubleRoundRobinMatchCount: "doubleRoundRobinMatchCount",
  duprId: "duprId",
  manualPaymentRecorded: "manualPaymentRecorded",
  onlinePaymentRecorded: "onlinePaymentRecorded",
  manualPaymentRecordedAt: "manualPaymentRecordedAt",
  amount: "amount",
  methods: "methods",
  provider: "provider",
  delivery: "delivery",
  selectedMatches: "selectedMatches",
  exportedMatches: "exportedMatches",
  skippedMatches: "skippedMatches",
  exportedPlayers: "exportedPlayers",
} as const;

export const MANAGER_AUDIT_FIELD_LABELS: Record<string, MessageKey> = Object.fromEntries(
  Object.entries(MANAGER_AUDIT_FIELD_LABEL_KEYS).map(([fieldKey, labelKey]) => [
    fieldKey,
    `auditLog.fields.manager.labels.${labelKey}`,
  ])
) as Record<string, MessageKey>;

export const MANAGER_NESTED_AUDIT_FIELD_LABELS: Record<string, MessageKey> = {
  // A bare `id` is NOT necessarily a public id: the backend's payload id
  // registry deliberately leaves the key unregistered (it collides with raw
  // child-row primary keys in `positionsRemoved[].id`, `order[].id`,
  // `factSheet[].id`), and the one place it IS a public id — inside a
  // `{ id, name }` entity reference — renders as the reference's label and
  // never reaches this map. Only `publicId` may promise a public id.
  id: "general.columns.id",
  publicId: "auditLog.fields.manager.labels.publicId",
  name: "auditLog.fields.manager.labels.name",
  title: "auditLog.fields.manager.labels.title",
  color: "auditLog.fields.manager.labels.color",
  lat: "auditLog.fields.manager.labels.latitude",
  lng: "auditLog.fields.manager.labels.longitude",
  skillLevel: "auditLog.fields.manager.labels.skillLevel",
  round: "auditLog.fields.manager.labels.round",
  roundNumber: "auditLog.fields.manager.labels.roundNumber",
  matchNumber: "auditLog.fields.manager.labels.matchNumber",
  entry1: "auditLog.fields.manager.labels.entry1",
  entry2: "auditLog.fields.manager.labels.entry2",
};

const MANAGER_AUDIT_VALUE_LABELS: Record<string, Record<string, MessageKey>> = {
  competitionType: {
    camp: "auditLog.fields.manager.values.competitionType.camp",
    clinic: "auditLog.fields.manager.values.competitionType.clinic",
    league_stage: "auditLog.fields.manager.values.competitionType.leagueStage",
    other: "auditLog.fields.manager.values.competitionType.other",
    tournament: "auditLog.fields.manager.values.competitionType.tournament",
  },
  status: {
    active: "auditLog.fields.manager.values.status.active",
    completed: "auditLog.fields.manager.values.matchStatus.completed",
    confirm: "auditLog.fields.manager.values.status.confirmed",
    decline: "auditLog.fields.manager.values.status.declined",
    inProgress: "auditLog.fields.manager.values.matchStatus.inProgress",
    inactive: "auditLog.fields.manager.values.status.inactive",
    merged: "auditLog.fields.manager.values.status.merged",
    partial_payment: "auditLog.fields.manager.values.status.partialPayment",
    payment_pending: "auditLog.fields.manager.values.status.paymentPending",
    pending: "auditLog.fields.manager.values.status.pending",
    upcoming: "auditLog.fields.manager.values.matchStatus.scheduled",
    withdrawn: "auditLog.fields.manager.values.status.withdrawn",
    Hidden: "auditLog.fields.manager.values.status.hidden",
  },
  matchStatus: {
    completed: "auditLog.fields.manager.values.matchStatus.completed",
    inProgress: "auditLog.fields.manager.values.matchStatus.inProgress",
    upcoming: "auditLog.fields.manager.values.matchStatus.scheduled",
  },
  paymentStatus: {
    PAID: "auditLog.fields.manager.values.paymentStatus.paid",
    PARTIALLY_PAID: "auditLog.fields.manager.values.paymentStatus.partiallyPaid",
    PENDING: "auditLog.fields.manager.values.paymentStatus.pending",
  },
  oopType: {
    DATE_RANGE: "auditLog.fields.manager.values.oopType.dateRange",
    SPECIFIC_TIME: "auditLog.fields.manager.values.oopType.specificTime",
    "date-range": "auditLog.fields.manager.values.oopType.dateRange",
    "specific-time": "auditLog.fields.manager.values.oopType.specificTime",
  },
  operation: {
    GROUP_ORDER_OF_PLAY: "auditLog.fields.manager.values.operation.groupOrderOfPlay",
    ALL_GROUPS_ORDER_OF_PLAY: "auditLog.fields.manager.values.operation.allGroupsOrderOfPlay",
    DRAW_ORDER_OF_PLAY: "auditLog.fields.manager.values.operation.drawOrderOfPlay",
    FORMAT_BLOCK_ORDER_OF_PLAY: "auditLog.fields.manager.values.operation.formatBlockOrderOfPlay",
    ALL_FORMAT_BLOCKS_ORDER_OF_PLAY:
      "auditLog.fields.manager.values.operation.allFormatBlocksOrderOfPlay",
    KINGS_FORMAT_ORDER_OF_PLAY: "auditLog.fields.manager.values.operation.kingsFormatOrderOfPlay",
    GROUP_PARTICIPANTS_SCHEDULE_REGENERATION:
      "auditLog.fields.manager.values.operation.groupParticipantsScheduleRegeneration",
  },
  slot: {
    entry1: "auditLog.fields.manager.values.slot.entry1",
    entry2: "auditLog.fields.manager.values.slot.entry2",
  },
  algorithm: {
    standard: "auditLog.fields.manager.values.algorithm.standard",
    zigzag: "auditLog.fields.manager.values.algorithm.zigzag",
  },
  generationMethod: {
    fromEntries: "auditLog.fields.manager.values.generationMethod.fromEntries",
    fromGroups: "auditLog.fields.manager.values.generationMethod.fromGroups",
    fromGroupsManual: "auditLog.fields.manager.values.generationMethod.fromGroupsManual",
    fromMainDraw: "auditLog.fields.manager.values.generationMethod.fromMainDraw",
    liveStandings: "auditLog.fields.manager.values.generationMethod.liveStandings",
    liveStandingsManual: "auditLog.fields.manager.values.generationMethod.liveStandingsManual",
    manual: "auditLog.fields.manager.values.generationMethod.manual",
  },
  scoreType: {
    Bye: "auditLog.fields.manager.values.scoreType.bye",
    Disq: "auditLog.fields.manager.values.scoreType.disqualified",
    Draw: "auditLog.fields.manager.values.scoreType.draw",
    Ret: "auditLog.fields.manager.values.scoreType.retired",
    TBF: "auditLog.fields.manager.values.scoreType.toBeFinished",
    "W/O": "auditLog.fields.manager.values.scoreType.walkover",
  },
  teamMatchType: {
    doubles: "auditLog.fields.manager.values.type.doubles",
    single: "auditLog.fields.manager.values.type.singles",
  },
  type: {
    "double-elimination": "auditLog.fields.manager.values.drawType.doubleElimination",
    "double-elimination-advanced":
      "auditLog.fields.manager.values.drawType.doubleEliminationAdvanced",
    "play-each-place": "auditLog.fields.manager.values.drawType.playEachPlace",
    "single-elimination": "auditLog.fields.manager.values.drawType.singleElimination",
    doubles: "auditLog.fields.manager.values.type.doubles",
    single: "auditLog.fields.manager.values.type.singles",
    team: "auditLog.fields.manager.values.type.teams",
    teams: "auditLog.fields.manager.values.type.teams",
  },
  generationMode: {
    king: "auditLog.fields.manager.values.generationMode.king",
    roundRobin: "auditLog.fields.manager.values.generationMode.roundRobin",
  },
  methods: {
    "Bank transfer": "auditLog.fields.manager.values.paymentMethod.bankTransfer",
    Cash: "auditLog.fields.manager.values.paymentMethod.cash",
    Invoice: "auditLog.fields.manager.values.paymentMethod.invoice",
    "Online transfer": "auditLog.fields.manager.values.paymentMethod.onlineTransfer",
    Unknown: "auditLog.fields.manager.values.paymentMethod.unknown",
  },
  paymentMethod: {
    "Bank transfer": "auditLog.fields.manager.values.paymentMethod.bankTransfer",
    Cash: "auditLog.fields.manager.values.paymentMethod.cash",
    Invoice: "auditLog.fields.manager.values.paymentMethod.invoice",
    "Online transfer": "auditLog.fields.manager.values.paymentMethod.onlineTransfer",
    Unknown: "auditLog.fields.manager.values.paymentMethod.unknown",
  },
  provider: {
    WPR: "auditLog.fields.manager.values.provider.wpr",
    WTN: "auditLog.fields.manager.values.provider.wtn",
  },
  delivery: {
    api: "auditLog.fields.manager.values.delivery.api",
    download: "auditLog.fields.manager.values.delivery.download",
  },
  tier: {
    INTERNATIONAL: "tournament.enums.tier.INTERNATIONAL",
    LOCAL: "tournament.enums.tier.LOCAL",
    NATIONAL: "tournament.enums.tier.NATIONAL",
    REGIONAL: "tournament.enums.tier.REGIONAL",
  },
  sortOrder: {
    ASC: "auditLog.fields.manager.values.sortOrder.asc",
    DESC: "auditLog.fields.manager.values.sortOrder.desc",
  },
  sortBy: {
    DUPR: "auditLog.fields.manager.values.sortBy.dupr",
    POINTS: "auditLog.fields.manager.values.sortBy.points",
    RANK: "auditLog.fields.manager.values.sortBy.rank",
    RANKING: "auditLog.fields.manager.values.sortBy.ranking",
    REGISTRATION_DATE: "auditLog.fields.manager.values.sortBy.registrationDate",
    TOTAL_SCORE: "auditLog.fields.manager.values.sortBy.totalScore",
    WPR: "auditLog.fields.manager.values.sortBy.wpr",
    WTN: "auditLog.fields.manager.values.sortBy.wtn",
  },
  submissionType: {
    BothGalleryAndLiveMedia: "auditLog.fields.manager.values.submissionType.both",
    GalleryOnly: "auditLog.fields.manager.values.submissionType.galleryOnly",
    LiveMediaOnly: "auditLog.fields.manager.values.submissionType.liveOnly",
  },
  hideResultsType: {
    AllResultsAndMediaContent: "auditLog.fields.manager.values.hideResultsType.all",
    OnlyMediaContent: "auditLog.fields.manager.values.hideResultsType.mediaOnly",
  },
  discountType: {
    PROMO_CODE: "auditLog.fields.manager.values.discountType.promoCode",
  },
  skillLevel: {
    ADVANCED: "auditLog.fields.manager.values.skillLevel.advanced",
    BEGINNER: "auditLog.fields.manager.values.skillLevel.beginner",
    INTERMEDIATE: "auditLog.fields.manager.values.skillLevel.intermediate",
    LOWER_INTER: "auditLog.fields.manager.values.skillLevel.lowerIntermediate",
    OPEN: "auditLog.fields.manager.values.skillLevel.open",
    PRO: "auditLog.fields.manager.values.skillLevel.pro",
  },
  groupType: {
    kings: "auditLog.fields.manager.values.groupType.kings",
    standard: "auditLog.fields.manager.values.groupType.standard",
  },
  drawType: {
    "double-elimination": "auditLog.fields.manager.values.drawType.doubleElimination",
    "double-elimination-advanced":
      "auditLog.fields.manager.values.drawType.doubleEliminationAdvanced",
    "play-each-place": "auditLog.fields.manager.values.drawType.playEachPlace",
    "single-elimination": "auditLog.fields.manager.values.drawType.singleElimination",
  },
  pairingsBlockType: {
    AMERICANO: "auditLog.fields.manager.values.pairingsBlockType.americano",
    KNOCKOUT: "auditLog.fields.manager.values.pairingsBlockType.knockout",
    MEXICANO: "auditLog.fields.manager.values.pairingsBlockType.mexicano",
    ROUND_ROBIN: "auditLog.fields.manager.values.pairingsBlockType.roundRobin",
    SWISS: "auditLog.fields.manager.values.pairingsBlockType.swiss",
    WINNERS_COURT: "auditLog.fields.manager.values.pairingsBlockType.winnersCourt",
  },
  listAndResultType: {
    custom: "auditLog.fields.manager.values.listAndResultType.custom",
    "unit-or-discipline-base": "auditLog.fields.manager.values.listAndResultType.unitOrDiscipline",
  },
  customMatricesType: {
    "unit-and-time-base": "auditLog.fields.manager.values.customMatricesType.unitAndTime",
  },
  leagueType: {
    advanced: "auditLog.fields.manager.values.leagueType.advanced",
    basic: "auditLog.fields.manager.values.leagueType.basic",
  },
};

export const resolveManagerAuditLogValueLabelKey = (
  fieldKey: string | undefined,
  value: string
): MessageKey | null => (fieldKey ? (MANAGER_AUDIT_VALUE_LABELS[fieldKey]?.[value] ?? null) : null);
